import classNames from "classnames";
import PropTypes from "prop-types";

import { LegendContainer } from "./HistoricalPerformanceChart.styles";
import { numberSeparator } from "utils";
import { TIME_INDICATOR } from "utils/constants";

const LegendContent = ({
  payload,
  gainPercentage,
  gain,
  benchmarkPerc,
  benchmark,
  activeValue,
  firstValue,
  bmKey,
  stratKey,
  isTooltipActive,
  activePeriod,
}) => {
  const formattedGainPerc = () => {
    if (gainPercentage) {
      return numberSeparator(gainPercentage)?.replace("-", "");
    }
    return gainPercentage;
  };

  const formattedGain = () => {
    if (gain) {
      return numberSeparator(gain)?.replace("-", "");
    }
    return gain;
  };

  return (
    <LegendContainer className="">
      {payload.map((entry, i) => (
        <li key={i} style={{ display: "flex" }}>
          <div>
            <span
              className="line"
              style={{ backgroundColor: entry.payload.stroke }}
            ></span>
            <span className="name">{entry.value}</span>
          </div>

          {entry.value === stratKey && (
            <>
              <span
                className={classNames("value", {
                  gain: activeValue >= firstValue,
                  loss: activeValue < firstValue,
                })}
              >
                {activeValue >= firstValue ? "+" : "-"}${formattedGain()} (
                {activeValue >= firstValue ? "+" : "-"}
                {formattedGainPerc()}%)
              </span>
              <span className="date">
                {!isTooltipActive && TIME_INDICATOR[activePeriod.toUpperCase()]}
              </span>
            </>
          )}

          {entry.value === bmKey && (
            <div style={{ color: benchmark?.color }} className="value">
              ${numberSeparator(benchmark?.value)} ({benchmarkPerc}%)
            </div>
          )}
        </li>
      ))}
    </LegendContainer>
  );
};

LegendContent.propTypes = {
  payload: PropTypes.array,
  gain: PropTypes.number,
  gainPercentage: PropTypes.number,
  benchmarkPerc: PropTypes.number,
  benchmark: PropTypes.number,
  activeValue: PropTypes.number,
  firstValue: PropTypes.number,
  isTooltipActive: PropTypes.bool,
  bmKey: PropTypes.string,
  stratKey: PropTypes.string,
  activePeriod: PropTypes.string,
};

export { LegendContent };
